import TemplateList from '@/modules/templates/pages/TemplateListPage'

export default [
  {
    name: 'Templates',
    path: '/content/templates/index',
    component: TemplateList,
    meta: {
      auth: ['CampaignTemplate:ReadAccess', 'CampaignTemplate:FullAccess'],
      title: 'Templates'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/templates/router/index.js